export default __webpack_public_path__ + "static/media/eternity.70e62fde.jpg";